var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro_wrap"},[_c('div',{staticClass:"intro"},[_c('page-header',{staticClass:"not_main"}),_c('div',{staticClass:"intro_content"},[_c('image-component',{attrs:{"infoType":'fatherBanner'}}),_c('terms-component',{attrs:{"terms-type":`stipulation`}})],1),_c('page-footer',{staticClass:"not_main"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }